import {
  Box,
  Button,
  Alert,
  AlertIcon,
  AlertDialog,
  AlertDialogBody,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogContent,
  AlertDialogOverlay,
  HStack,
  Center,
  VStack,
  Heading,
  Divider,
  Text,
  Accordion,
  AccordionItem,
  AccordionButton,
  AccordionPanel,
  AccordionIcon,
} from "@chakra-ui/react"
import Head from "next/head"
import { useState, useRef } from "react"
import { useRouter } from "next/router"
import useMemberStore from "@/store/MemberStore"
import * as amplitude from "@amplitude/analytics-browser"
import * as pixel from "@/utils/pixel"
const _ = require("lodash")

function InfluencersSignupPage() {
  const router = useRouter()
  const [isLoading, setIsLoading] = useState(false)
  const [isSignedUp, setIsSignedUp] = useState(false)
  const { isLoggedIn } = useMemberStore()
  const cancelRef = useRef()

  const title = `加入 Threads 網紅/創作者雷達`
  const description = `加入 Threads 網紅/創作者雷達，讓品牌主更容易找到你！`

  const handleButtonClicked = () => {
    pixel.log({ name: "Click_Join_Influencer" })
    if (isLoggedIn) {
      return
    }
    amplitude.track("JoinInfluencerButtonClicked")
    router.push("/signup/influencer")
  }

  const handleIsSignedUpButtonClicked = () => {
    router.push("/")
  }

  if (isSignedUp) {
    return (
      <Box>
        <AlertDialog isOpen={isSignedUp} leastDestructiveRef={cancelRef}>
          <AlertDialogOverlay>
            <AlertDialogContent>
              <AlertDialogHeader fontSize="lg" fontWeight="bold">
                <Alert status="success" variant="subtle">
                  <AlertIcon />
                  登記成功
                </Alert>
              </AlertDialogHeader>
              <AlertDialogBody>
                您已加入創作者雷達計畫
                <br />
                讓您更有機會被品牌主找到，進而增加合作機會！
                <br />
                未來若有更多關於此計畫的消息，我們會發信通知
              </AlertDialogBody>
              <AlertDialogFooter>
                <HStack>
                  <Button
                    ref={cancelRef}
                    onClick={handleIsSignedUpButtonClicked}
                    colorScheme="blue">
                    好
                  </Button>
                </HStack>
              </AlertDialogFooter>
            </AlertDialogContent>
          </AlertDialogOverlay>
        </AlertDialog>
      </Box>
    )
  }

  return (
    <Box marginTop="40px">
      <Head>
        <title>{title}</title>
        <meta name="og:title" content={title} />
        <meta name="og:description" content={description} />
        <meta name="description" content={description} />
      </Head>
      <Box>
        <Center>
          <VStack>
            <Heading>Threads 創作者雷達</Heading>
            <Divider />
            <Text
              fontSize="lg"
              align="center"
              textColor="text.semidark"
              marginTop="8px">
              加入 Threads 創作者雷達，讓有需求的品牌主更容易在茫茫大海中找到你
              <br />
              讓你接到更多合作機會！
            </Text>
            <Button
              marginTop="16px"
              size="lg"
              background="main.red"
              isLoading={isLoading}
              onClick={handleButtonClicked}>
              免費加入
            </Button>
          </VStack>
        </Center>
        <Box marginTop="48px">
          <Accordion defaultIndex={[0, 1]} allowMultiple>
            <AccordionItem>
              <h1>
                <AccordionButton>
                  <Text fontSize="17px" as="b" flex="1" textAlign="left">
                    創作者雷達計畫可以幫助我什麼？
                  </Text>
                  <AccordionIcon />
                </AccordionButton>
              </h1>
              <AccordionPanel pb={4}>
                我們會分析您的
                Threads，如：類型（如：美妝）、貼文成效、追蹤者性別比例等⋯{" "}
                <br />
                品牌主會在我們的服務上搜尋與他們需求相符的 Threads 帳號 <br />
                若帳號特性相符，它們可以和您聯絡洽談合作事宜，提高您的曝光度！
              </AccordionPanel>
            </AccordionItem>
            <AccordionItem>
              <h1>
                <AccordionButton>
                  <Text fontSize="17px" as="b" flex="1" textAlign="left">
                    要錢嗎？
                  </Text>
                  <AccordionIcon />
                </AccordionButton>
              </h1>
              <AccordionPanel pb={4}>
                我們是來幫你賺錢的，不是讓你花錢，完全不用付費！
              </AccordionPanel>
            </AccordionItem>
          </Accordion>
        </Box>
      </Box>
    </Box>
  )
}

export async function getServerSideProps(context: { query: any }) {
  const locale = context.locale
  const headers = context.req.headers
  const acceptLanguage = headers["accept-language"]
  let lang = "en-US"
  if (
    _.includes(locale, "en") &&
    (_.includes(acceptLanguage, "zh-TW") || _.includes(acceptLanguage, "zh"))
  ) {
    lang = "zh-TW"
  }

  return {
    props: {
      messages: (await import(`@/messages/${context.locale}.json`)).default,
      // messages: (await import(`@/messages/zh-TW.json`)).default,
      lang,
    },
  }
}

export default InfluencersSignupPage
